import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatModule } from './mat-module';
import { GoNextDirective } from '../appDirectives/go-next.directive';
import { NumbersOnlyDirective } from '../appDirectives/numbers-only.directive';
import { HttpClientModule } from '@angular/common/http';
import { OrderTypeDialogComponent } from '../includes/popups/order-type-dialog/order-type-dialog.component';
import { PromptComponent } from '../includes/popups/prompt/prompt.component';
import { BackPromptComponent } from '../includes/popups/back-prompt/back-prompt.component';
import { VoiceModelComponent } from '../includes/popups/voice-model/voice-model.component';
import { VisualCueComponent } from '../includes/visual-cue/visual-cue.component';
import { CountdownComponent } from '../includes/countdown/countdown.component';
import { BackComponent } from '../includes/back/back.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { UserInactivityModelComponent } from '../includes/user-inactivity-model/user-inactivity-model.component';
import { RouterModule } from '@angular/router';
import { CustomSnackBarComponent } from '../includes/utilities/custom-snack-bar/custom-snack-bar.component';
import { SelectionListComponent } from '../includes/selection-list/selection-list.component';
import { SharedModule } from '../shared/shared.module';
import { TipComponent } from '../pages/checkout/tip/tip.component';
import { PaymentModeComponent } from '../pages/checkout/payment-mode/payment-mode.component';
@NgModule({
  declarations: [
    GoNextDirective,
    NumbersOnlyDirective,
    UserInactivityModelComponent,
    PromptComponent,
    OrderTypeDialogComponent,
    VisualCueComponent,
    CustomSnackBarComponent,
    BackComponent,
    BackPromptComponent,
    CountdownComponent,
    VoiceModelComponent,
    SelectionListComponent,
    TipComponent,
    PaymentModeComponent
  ],
  imports: [
    CommonModule,
    MatModule,
    HttpClientModule,
    NgxSkeletonLoaderModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    MatModule,
    GoNextDirective,
    SharedModule,
    NumbersOnlyDirective,
    HttpClientModule,

    PromptComponent,
    OrderTypeDialogComponent,
    VisualCueComponent,
    BackComponent,
    NgxSkeletonLoaderModule,
    VoiceModelComponent,
    CustomSnackBarComponent,
    RouterModule,
    BackPromptComponent,
    UserInactivityModelComponent,
    CountdownComponent,
    SelectionListComponent,
    TipComponent,
    PaymentModeComponent
  ],
  providers: [],
})
export class DesignUtilitiesModule {}
